var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroungFooterLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 295,
    viewBox: "0 0 241 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.5 -32C63.6328 -32 0.5 31.1328 0.5 109C0.5 139.662 10.5521 167.797 27.2606 190.839C27.5603 191.391 27.6073 192.008 27.948 192.537L121.948 333.537C126.307 340.076 133.651 344 141.5 344C149.349 344 156.693 340.076 161.052 333.537L255.052 192.537C255.399 192.008 255.44 191.391 255.739 190.839C272.448 167.797 282.5 139.662 282.5 109C282.5 31.1328 219.367 -32 141.5 -32ZM141.5 156C115.544 156 94.5 134.956 94.5 109C94.5 83.0443 115.544 62 141.5 62C167.456 62 188.5 83.0443 188.5 109C188.5 134.956 167.456 156 141.5 156Z",
    fill: "white",
    fillOpacity: 0.1,
    stroke: "black",
    strokeWidth: 0.00125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroungFooterLocation);
export default __webpack_public_path__ + "static/media/backgroung_footer-location.ed9b4d5339900b7728d7f51ee0fe3a45.svg";
export { ForwardRef as ReactComponent };